import RestEdit from 'containers/rest/Edit';
import Form from '../components/Form';
import { useSelector } from '@redux';
import { DynamicObjectType } from 'types/commons';
import { omit } from 'lodash';

export default function Edit() {
  const currUser = useSelector<DynamicObjectType>(
    (state) => state.users.currentData,
  );

  const breadcrumbs = [
    {
      title: 'common.page.users',
      href: '/users',
    },
    {
      title: `#${currUser?.id}`,
    },
  ];

  const handleDataConvert = (record) => {
    return {
      ...record,
      locationCode:
        record?.locationCode?.split(',')?.map((item) => ({
          id: item,
        })) || [],
      chainStore:
        record?.chainStore?.split(',')?.map((item) => ({
          id: item,
        })) || [],
    };
  };

  return (
    <RestEdit
      model="users"
      breadcrumbs={breadcrumbs}
      apiOptions={{
        extraParams: {
          join: ['roles'],
        },
        isRequestApi: true,
        isShowSuccessNoti: true,
      }}
      formatOnSubmit={(values) => ({
        ...omit(values, ['phoneNumber']),
        locationCode: values?.locationCode?.length
          ? values?.locationCode?.map((item) => item?.id).join(',')
          : null,
        chainStore: values?.chainStore?.length
          ? values?.chainStore?.map((item) => item?.id).join(',')
          : null,
        isActive: !!values.isActive,
      })}
      handleDataConvert={handleDataConvert}
      customPathAfterSubmit="users"
      customUrlBack="/users"
    >
      <Form isEdit currentData={currUser} />
    </RestEdit>
  );
}
